import React from 'react';
import {LoaderCircle} from 'lucide-react';
import {useLanguage} from '../lib/Language.jsx';

export default function AuthLoading(){
  const {t}=useLanguage();
  return <main className="auth-loading" aria-busy="true"><section role="status" aria-live="polite"><LoaderCircle className="auth-spinner" size={44} aria-hidden="true"/><h1>{t('Signing you in…')}</h1><p>{t('Please wait while we get your account ready.')}</p></section></main>;
}
